import Logo from "../common/Logo";

// Shared chrome for static info pages (Privacy Policy, Terms & Conditions) so
// both read consistently and neither duplicates the header/back-button markup.
export default function LegalPageLayout({ title, subtitle, updatedLabel, onClose, children }) {
  return (
    <div className="flex-1 min-w-0 h-full overflow-y-auto bg-gray-950 text-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12">

        <div className="flex items-start sm:items-center justify-between gap-4 mb-8">
          <div className="flex items-center gap-3 min-w-0">
            <Logo size={36} className="hidden sm:block" />
            <div className="min-w-0">
              <h1 className="text-2xl sm:text-3xl font-bold truncate">{title}</h1>
              {subtitle && <p className="text-gray-500 text-sm mt-1">{subtitle}</p>}
            </div>
          </div>

          {onClose && (
            <button
              onClick={onClose}
              className="text-sm bg-gray-900 hover:bg-gray-800 border border-gray-800 px-4 py-2 rounded-xl transition shrink-0"
            >
              Back
            </button>
          )}
        </div>

        {updatedLabel && (
          <p className="text-xs text-gray-600 mb-8">{updatedLabel}</p>
        )}

        <div className="space-y-8 text-sm leading-relaxed text-gray-300 pb-4">
          {children}
        </div>

      </div>
    </div>
  );
}

// Small consistent section heading used by both legal documents.
export function LegalSection({ title, children }) {
  return (
    <section>
      <h2 className="text-white font-semibold text-base mb-2.5">{title}</h2>
      <div className="space-y-2.5">{children}</div>
    </section>
  );
}
